var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-drawer',{attrs:{"visible":_vm.vModel,"with-header":false,"direction":"ltr","size":"20rem"},on:{"update:visible":function($event){_vm.vModel=$event}}},[_c('a',{staticClass:"logo"},[_c('img',{attrs:{"src":"/static/img/CMK_Logo.png"}})]),_vm._v(" "),_c('Menu')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c53ea98","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Sidebar/index.vue
// module id = null
// module chunks = 